<template>
  <v-container class="iframe-body modal_content" text-center>
    <!-- SKELETON LOADER HERE  v-show="!loading" -->
    <v-layout row no-gutters justify-space-between wrap>
      <v-flex
        class="welcome-section intro"
        style="padding-right: 13px !important;"
        sm7
        xs12
      >
        <h1 class="welcome mb-5">{{ $t('welcome.title') }}</h1>
        <h4 class="mb-5">{{ $t('welcome.text1') }}</h4>
        <v-flex
          v-if="walletStatus !== WALLET_CONNECTED"
          class="status-wallet py-3"
        >
          <h4 class="mb-6" v-html="$t('welcome.text2')"></h4>
          <div class="wallet">
            <div class="status">
              <v-icon size="14" :color="$t('status.' + walletStatus + '.color')"
                >fiber_manual_record</v-icon
              >
              {{ $t('status.' + walletStatus + '.msg') }}
            </div>
          </div>
        </v-flex>
        <!-- <p :class="showIdentitiesStatus ? '' : 'mt-12'" v-if="hasAssets"> -->
        <v-checkbox
          v-if="hasPlugin && false"
          v-model="terms"
          color="#01a3b0"
          class="mt-8"
        >
          <div slot="label" class="terms">
            {{ $t('welcome.terms[0]') }}
            <a
              slot="activator"
              target="_blank"
              color="#01a3b0"
              href="https://wallidtsp.io/termsiframe"
              @click.stop
            >
              {{ $t('welcome.terms[1]') }}
              <img src="@/assets/link.svg" class="Shape" />
            </a>
          </div>
        </v-checkbox>
      </v-flex>
      <v-flex class="welcome-image d-none d-sm-flex pt-16" sm5>
        <img contain width="348" height="258" src="@/assets/imgs/welcome.png" />
      </v-flex>
    </v-layout>
    <!-- <skeleton-loader :loading="loading" /> -->
    <v-footer fixed class="iframe-footer modal_footer" id="wallid-footer">
      <v-container grid-list-md text-center>
        <v-layout wrap justify-end>
          <v-btn
            id="begin"
            v-if="errorMsg == 'noComp'"
            @click="downloadChrome"
            depressed
            class="button-iframe"
            >{{ $t('button.download') }}</v-btn
          >
          <v-btn
            id="begin"
            v-else-if="walletStatus == NO_PLUGIN"
            @click="storeIDS"
            depressed
            class="button-iframe"
            >{{ $t('button.getPlugin') }}</v-btn
          >
          <v-btn
            id="begin"
            v-else-if="walletStatus == NO_WALLET"
            @click="storeIDS"
            depressed
            class="button-iframe"
            >Setup MyWalliD</v-btn
          >
          <v-btn
            id="begin"
            v-else
            :loading="loadingBtn"
            :disabled="isDisabled"
            @click="beginSign"
            depressed
            class="button-iframe"
            >{{ beginBtnText }}</v-btn
          >

          <!-- <v-btn
            id="begin"
            v-else-if="!hasPlugin && !loading && errorMsgStatus != 'loggedOut'"
            @click="storeIDS"
            depressed
            class="button-iframe"
            >{{ $t('button.getPlugin') }}</v-btn
          > -->
          <!-- <v-btn
            id="begin"
            v-else-if="
              isOnboardingComplete &&
                !walletAddress &&
                !loading &&
                errorMsgStatus == 'ERR_PLUGIN_LOCKED'
            "
            @click="initiatePlugin"
            depressed
            class="button-iframe"
            >{{ $t('button.signIn') }}</v-btn
          > -->
          <!-- <v-btn
            id="begin"
            v-else-if="
              isOnboardingComplete &&
                !walletAddress &&
                !loading &&
                errorMsgStatus == 'ERR_NO_PERMISSION'
            "
            @click="initiatePlugin"
            depressed
            class="button-iframe"
            >{{ $t('button.connect') }}</v-btn
          > -->
          <!-- 
          <v-btn
            id="begin"
            v-else
            :disabled="isDisabled"
            @click="beginSign"
            depressed
            class="begin button-iframe"
            >{{ $t('button.begin') }}</v-btn
          > -->
        </v-layout>
      </v-container>
    </v-footer>
  </v-container>
</template>

<script>
const LOCKED = 'lockedWallet';
const NO_PLUGIN = 'noPlugin';
const NO_WALLET = 'noWallet';
const NO_ID_STORED = 'noIdStored';
const WALLET_CONNECTED = 'walletConnected';

import {
  WALLET_LIST,
  WALLET_ADDRESS,
  INITIATE_PLUGIN,
} from '@/stores/modules/walletConsts';

import { mapGetters, mapState, mapActions } from 'vuex';

import * as WallidConst from '@/wallid/const';

const logger = {
  log: require('debug')('iframe:welcomeView'),
  error: require('debug')('iframe:welcomeView:error'),
};

// import SkeletonLoader from '../../components/SkeletonLoader.vue';
export default {
  // components: { SkeletonLoader },
  name: 'Welcome',
  methods: {
    ...mapActions('plugin', {
      getWalletAddress: WALLET_ADDRESS,
      initiatePlugin: INITIATE_PLUGIN,
      getListAssets: WALLET_LIST,
    }),
    ...mapActions({
      handleAssets: 'HANDLE_ASSETS',
    }),
    getParentOrigin() {
      const locationAreDisctint = window.location !== window.parent.location;
      const parentOrigin = (
        (locationAreDisctint ? document.referrer : document.location) || ''
      ).toString();
      if (parentOrigin) {
        return new URL(parentOrigin).origin;
      }

      const currentLocation = document.location;

      if (
        currentLocation.ancestorOrigins &&
        currentLocation.ancestorOrigins.length
      ) {
        return currentLocation.ancestorOrigins[0];
      }

      return '';
    },
    async beginSign() {
      // this method handles all the states/steps now
      this.loadingBtn = true;
      logger.log('method beginSign');

      try {
        let res;
        if (
          this.walletStatus == 'ERR_NO_PERMISSION' ||
          this.walletStatus == LOCKED
        ) {
          if (this.walletStatus == 'ERR_NO_PERMISSION') {
            this.$gtag.event('Connect to MyWalliD', {
              event_category: 'ETH',
              event_label: 'welcome screen',
            });
          } else {
            this.$gtag.event('Sign in with MyWalliD', {
              event_category: 'ETH',
              event_label: 'welcome screen',
            });
          }

          res = await this.initiatePlugin();
        }

        if (res == 'REJECTED') {
          logger.error('initiatePlugin error', res);
          return;
        }

        this.$store.commit('errorMsgStatus', '');

        // now call get id assets

        if (!this.hasAssets) {
          this.$gtag.event('Authorize MyWalliD', {
            event_category: 'ETH',
            event_label: 'welcome screen',
          });

          const assets = await this.getListAssets();
          logger.log('getListAssets', assets);
          if (assets == 'REJECTED') {
            logger.error('getListAssets error', assets);
            return;
          }
          await this.handleAssets(assets);
        }
        logger.log('handleAssets', this.hasAssets);
        // this.$store.commit('start');
        if (this.hasAssets) {
          this.$store.commit('errorMsgStatus', '');
          this.$store.commit('loading', false);
          this.$router.push({ name: 'Identity' });
          // this.$router.push({ name: 'Success' });
        }
      } catch (errorMsg) {
        this.snackbar = true;

        if (errorMsg !== 'REJECTED') {
          const {
            event,
            event_category,
            event_label,
            message,
            type,
          } = errorMsg;

          if (type == 'banner') {
            this.$store.commit('errorMsg', message);
          } else {
            this.errorMsg[type] = message;
          }

          this.$gtag.event(event, {
            event_category,
            event_label,
          });
        }
      } finally {
        this.loadingBtn = false;
      }
    },
    downloadChrome() {
      this.$gtag.event('Download google chrome', {
        event_category: 'ETH',
        event_label: 'welcome screen',
      });

      let chromeURL = 'https://www.google.com/intl/pt-PT/chrome/';
      window.open(chromeURL, '_blank');
    },
    storeIDS() {
      if (this.walletStatus == this.NO_PLUGIN) {
        this.$gtag.event('Get MyWalliD', {
          event_category: 'ETH',
          event_label: 'welcome screen',
        });
      } else {
        this.$gtag.event('Setup MyWalliD', {
          event_category: 'ETH',
          event_label: 'welcome screen',
        });
      }

      var currentUrl = this.getParentOrigin();
      let wallidURL =
        WallidConst.WEBSITE_URL +
        '?currentAsset=MyWalliD&returnURL=' +
        encodeURIComponent(currentUrl) +
        `&gtag=${window.GA_ID}`;

      // let downloadUrl =
      //   'https://chrome.google.com/webstore/detail/wallid-wallet/eknlkogikcabnjbjnhmjllabckeapdii?hl=pt-PT';
      window.open(wallidURL, '_blank');

      if (this.hasPlugin) {
        window.onfocus = this.onFocusCheckIDS;
      } else if (
        localStorage.getItem('checkWallet') &&
        localStorage.getItem('checkWallet') != 'walletInstaled'
      ) {
        localStorage.setItem('checkWallet', 'Onboarding');
        window.onfocus = this.onFocusCheckWeb3;
      }
    },
    async onFocusCheckIDS() {
      if (!this.walletAddress) {
        this.$store.commit('errorMsgStatus', 'ERR_NO_PERMISSION');
        await this.initiatePlugin();
      }
      this.$store.commit('errorMsgStatus', '');

      let assets = await this.getListAssets();
      await this.handleAssets(assets);
      // await this.beginSign();
      this.$store.commit('loading', false);
      // if (this.terms) {
      this.$router.push({ name: 'Identity' });
      // }
      // this.errorMsgStatus = 'noIdentitiesTimed';
    },
    onFocusCheckWeb3() {
      if (!this.hasPlugin) {
        //probally need to change this to window.open
        this.$router.go();
        // eslint-disable-next-line no-self-assign
        // document.location.href = document.location.href;
      }
    },
  },

  created() {
    logger.log('*** Welcome Created ***');

    window.onfocus = this.onFocusCheckWeb3;

    if (window.ERROR_CODE == '504') {
      logger.log(window.ERROR_CODE, this.$t('errors.notPDF'));

      const fileNames = window.ERROR_MESSAGE.replaceAll(';', ', ').slice(0, -2);
      this.$store.commit(
        'errorMsg',
        `${fileNames} ${this.$t('errors.notPDF')}`
      );
    }

    if (window.ERROR_CODE == '505') {
      logger.log(window.ERROR_CODE, this.$t('errors.alreadySigned'));
      this.$store.commit('errorMsg', 'alreadySigned');
    }
  },
  computed: {
    ...mapGetters([
      'browser',
      'loading',
      'hasAssets',
      'showIdentitiesStatus',
      'errorMsgStatus',
      'hasAssets',
    ]),

    ...mapGetters('plugin', {
      isOnboardingComplete: 'isOnboardingComplete',
      walletAddress: 'walletAddress',
    }),

    ...mapState('plugin', {
      hasPlugin: 'hasPlugin',
    }),

    walletStatus() {
      logger.log('walletStatus', this.hasPlugin);
      logger.log('isOnboardingComplete', this.isOnboardingComplete);

      if (!this.hasPlugin) {
        return this.NO_PLUGIN;
      } else if (!this.isOnboardingComplete) {
        return this.NO_WALLET;
      } else if (
        this.errorMsgStatus == 'notConnected' ||
        this.errorMsgStatus == 'ERR_NO_PERMISSION'
      ) {
        return this.errorMsgStatus;
      } else if (!this.walletAddress) {
        return LOCKED;
      } else if (this.walletAddress && !this.hasAssets) {
        return 'noIdAssetList';
      } else {
        return this.WALLET_CONNECTED;
      }
    },
    beginBtnText() {
      if (
        this.errorMsgStatus == 'notConnected' ||
        this.errorMsgStatus == 'ERR_NO_PERMISSION'
      ) {
        return this.$t('button.connect');
      }

      if (this.walletStatus == 'noIdAssetList') {
        return this.$t('button.getIdAssetList');
      }

      if (this.walletStatus == WALLET_CONNECTED) {
        return this.$t('button.begin');
      }

      if (this.walletStatus == LOCKED) {
        return this.$t('button.signIn');
      }

      if (this.walletStatus == NO_PLUGIN) {
        return this.$t('button.getPlugin');
      }

      return 'missing text';

      // if (!this.hasPlugin) {
      //   return this.NO_PLUGIN;
      // } else if (!this.isOnboardingComplete) {
      //   return this.NO_WALLET;
      // } else if (
      //   this.errorMsgStatus == 'notConnected' ||
      //   this.errorMsgStatus == 'ERR_NO_PERMISSION'
      // ) {
      //   return this.errorMsgStatus;
      // } else if (this.walletAddress) {
      //   return this.WALLET_CONNECTED;
      // } else {
      //   return this.LOCKED;
      // }
    },
    isDisabled() {
      if (
        // this.walletStatus == this.LOCKED ||
        // this.walletStatus == this.NO_WALLET ||
        this.walletStatus == this.NO_PLUGIN
      )
        return false;
      // if (!this.terms) return true;
      // if (!this.hasAssets) return true;

      return false;
    },

    terms: {
      get() {
        return this.$store.state.terms;
      },
      set(value) {
        this.$store.commit('terms', value);
      },
    },
    errorMsg: {
      get() {
        return this.$store.state.errorMsg;
      },
      set(newValue) {
        return this.$store.commit('errorMsg', newValue);
      },
    },
  },
  watch: {
    terms() {
      this.$gtag.event('Terms and conditions (checkbox)', {
        event_category: 'ETH',
        event_label: 'welcome screen',
      });
    },
  },
  data() {
    return {
      alert: require('@/assets/alert.svg'),

      transition: 'scale-transition',
      loadingBtn: false,
      LOCKED,
      NO_PLUGIN,
      NO_WALLET,
      NO_ID_STORED,
      WALLET_CONNECTED,
    };
  },
};
</script>

<style lang="scss" scoped>
a {
  color: #01a3b0;
}
a:hover {
  color: #01a3b0;
}
.Shape {
  width: 14px;
  height: 14px;
  object-fit: contain;
}
img.Shape {
  vertical-align: initial;
}
.cancel {
  height: 36px;
  margin: 0px;
  border-radius: 2px;

  margin-right: 632px;
  margin-left: 24px;
  color: #035b60;
}
.bottom {
  margin-top: 12px;
  margin-bottom: 12px;
}

.line {
  margin-top: 50px;
  margin-bottom: 11px;
}
</style>
